import styled from 'styled-components';

export const StyledCard = styled.div<{ isDisabled?: boolean }>`
  background-color: ${({ isDisabled, theme }) =>
    isDisabled ? theme.colors.decorative.neutral[50] : theme.colors.surface[0]};
  border: 1px solid ${({ isDisabled, theme }) => (isDisabled ? theme.colors.warning[200] : theme.colors.on[100])};
  border-radius: ${({ theme }) => theme.radii.xl}px;
  padding: ${({ theme }) => theme.spacing(4)}px;
  text-align: left;
  width: calc(100% - ${({ theme }) => theme.spacing(8)}px);
`;
